import Vuex from 'vuex'

import { alert } from './alert.module'
import { memberModule } from './member.module'
import { emailTemplateModule } from './email-template.module'
import { emailTemplateSettingsModule } from './email-template-settings.module'
import { blogModule } from './blog.module'
import { emailModule } from './email.module'
import { subscriptionModule } from './subscription.module'
import { promotionModule } from './promotion.module'
import { actionModule } from './action.module'
import { autoSubscriptionModule } from './auto-subscription.module'
import { eventsLogModule } from './events-log.module'
import { offerModule } from './offer.module'
import { emailFlowModule } from "./email-flow.module";
import { sponsorBoxModule } from "./sponsor-box.module";
import { blogEmailFlowModule } from "./blog-email-flow.module";
import { ctaModule } from "./cta.module";
import { groupSubscriptionModule } from "./group-subscription.module";
import { blogCustomSendingDomainModule } from "./blog-custom-sending-domain.module";
import { membersCleanupModule } from "./members-cleanup.module.js";
import { gatedPdfModule } from "./gated-pdf.module.js";
import { shippingAddressModule } from "./shipping-address.module.js";
import { postsPaywallModule } from "./posts-paywall.module.js";
import { postsEventModule } from "./posts-event.module.js";
import { emailCampaignModule } from "./email-campaign.module.js";
import { subscriptionScheduleModule } from "./subscription-schedule.module.js";
import { membersSpamFilterModule } from "./members-spam-filter.module.js";

export const store = new Vuex.Store({
  modules: {
    alert,
    memberModule,
    emailTemplateModule,
    blogModule,
    emailModule,
    emailTemplateSettingsModule,
    subscriptionModule,
    promotionModule,
    actionModule,
    autoSubscriptionModule,
    eventsLogModule,
    emailFlowModule,
    sponsorBoxModule,
    blogEmailFlowModule,
    ctaModule,
    groupSubscriptionModule,
    offerModule,
    blogCustomSendingDomainModule,
    membersCleanupModule,
    gatedPdfModule,
    shippingAddressModule,
    postsPaywallModule,
    postsEventModule,
    emailCampaignModule,
    subscriptionScheduleModule,
    membersSpamFilterModule,
  }
})
